<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1+DObbgImC3RYvh1Ov4lxcF8/qFCl7HwI0=",
    "cpf": "U2FsdGVkX19Fhhn9/uIh2W//kokF9cqDsIJFd0Fq8CQ="
  },
  {
    "num_cand": "U2FsdGVkX1/ISTOK8aTSl6DtqSdG/lr5M5KG631cR58=",
    "cpf": "U2FsdGVkX1+KTuHckbVZ5xe0v+kijXsgxwr2xDdH09g="
  },
  {
    "num_cand": "U2FsdGVkX1/RMYSNXRdKei9D2owCeRLIImpIM+HOy1Q=",
    "cpf": "U2FsdGVkX1/IzHHmH11GgyJ4ndRNytLFgAyIUcvXaac="
  },
  {
    "num_cand": "U2FsdGVkX1/fPeZ3dvFiEecXmKpsnSin95wHU3EaAu4=",
    "cpf": "U2FsdGVkX1/syePAY4ZMEBL52UpuL6+9wCvid2UsYQE="
  },
  {
    "num_cand": "U2FsdGVkX19KNFNdVDbGrs6URL3yN75BcXlmm3z2ycM=",
    "cpf": "U2FsdGVkX18JlWSD3SR7BWaN/BREgv6hIKobqRAihIE="
  },
  {
    "num_cand": "U2FsdGVkX1+Q1pGgvos8wP6N2QS1YwGWHJ/3iifJufM=",
    "cpf": "U2FsdGVkX1/xySacEFI5QLUbb1avqGC4KD7NgIySj/8="
  },
  {
    "num_cand": "U2FsdGVkX18vi9gEFEizovzgmdscNoPy7RLVS/7CAf4=",
    "cpf": "U2FsdGVkX1/u9vTNJgn+qkxfL5w2tbTgW6OzRTYw1v0="
  },
  {
    "num_cand": "U2FsdGVkX18jtrkgAU96Mx9CJId6vPT7dzpW7dEcHDs=",
    "cpf": "U2FsdGVkX1+7LkkKX8BketlmS38qEi97uSqTjH8ev2U="
  },
  {
    "num_cand": "U2FsdGVkX1/Tbcax6ILRoTFil+SHxm1LFjCnMuzmAKQ=",
    "cpf": "U2FsdGVkX1/leXqm5egB+7We9Cp1bWjV2wHikfnqAkY="
  },
  {
    "num_cand": "U2FsdGVkX1/oKWQBiFBClVGo6nGT9nfjJUEu7GdoOZY=",
    "cpf": "U2FsdGVkX18/nXtzwBZT1WAjB7mOy7lboHOkP39JvlE="
  },
  {
    "num_cand": "U2FsdGVkX1/K6BB5u8LXU4sXont3kUQ1dKmCSkYFhoo=",
    "cpf": "U2FsdGVkX197qIume0t2jFAzZpRpY+Uuakgl7SWyya8="
  },
  {
    "num_cand": "U2FsdGVkX1+EdRQ8Bnbawnr53+lgEwKpf44gAyjuJsc=",
    "cpf": "U2FsdGVkX1+0QPq9Nd4/pidkq5NSvSo1sZKbft+Cr1c="
  },
  {
    "num_cand": "U2FsdGVkX18d0KuSNjg2LKEFEfkrOQduJ3nOiaRUGiQ=",
    "cpf": "U2FsdGVkX1/0oIVdgPvmjagcQ89poOV7tf7qaqR4ChI="
  },
  {
    "num_cand": "U2FsdGVkX18sNDoDzIq7B1Ezyad3SVJW9y68NOYAp+Y=",
    "cpf": "U2FsdGVkX1+E9wDOpMXElWRUb089Y++wpedQPxBD/PM="
  },
  {
    "num_cand": "U2FsdGVkX19Ef09i9kM6xvamqoWmyhAenm4TSA210x4=",
    "cpf": "U2FsdGVkX18xwQiE9pI/nA5EYaF1iEukQjbFjeLl9tc="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2203/2203_rec_ped_isen/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
